module.exports = __webpack_public_path__ + "static/media/D9.a33e36fa.png";